import React, { useContext } from "react";
import classNames from "classnames";
import { QuestionContent } from "../QuestionContent";
import { QuestionContext } from "../../context";

export function QuestionFill({ className, children, style }: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "Fill") throw new Error("error type data");

    return (
        <div className={classNames("QuestionFill", className)} style={style}>
            <QuestionContent />
            {children}
        </div>
    );
}
